export async function persistMappingVerification<MappingId, Status>({
  mappingId,
  status,
  mutate,
  errorMessage,
  onBusyChange,
  onErrorChange,
}: {
  readonly mappingId: MappingId;
  readonly status: Status;
  readonly mutate: (args: { mappingId: MappingId; status: Status }) => Promise<unknown>;
  readonly errorMessage: (error: unknown) => string;
  readonly onBusyChange: (mappingId: MappingId | null) => void;
  readonly onErrorChange: (message: string | null) => void;
}): Promise<boolean> {
  onBusyChange(mappingId);
  onErrorChange(null);
  try {
    await mutate({ mappingId, status });
    return true;
  } catch (error) {
    onErrorChange(errorMessage(error));
    return false;
  } finally {
    onBusyChange(null);
  }
}
